import { matchPath } from "react-router-dom";

// List pages float the top bar; project analytics puts it in its SubPageHeader.
export const TOP_BAR_PATHS: string[] = [
  "/home",
  "/media/projects",
  "/media/analytics",
  "/playbooks",
  "/media/brandkits",
  "/media/contacts",
  "/media/presenters",
  "/media/voices",
  "/media/documents",
  "/workspaces",
  "/organization",
  "/settings",
  "/whats-new",
];

export const isTopBarPage = (pathname: string): boolean =>
  TOP_BAR_PATHS.some((path) => matchPath({ path, end: true }, pathname));
